"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
exports.createScreenshot = graphql_tag_1.default `
  mutation createScreenshot(
    $options: SnapScreenshotOptions!
  ) {
    createScreenshot(
      options: $options
    ) {
      url
      id
    }
  }
`;
exports.uploadFile = graphql_tag_1.default `
  mutation uploadFile(
    $file: Upload!,
    $public: Boolean!
  ) {
    uploadFile(
      file: $file, 
      public: $public
    ) {
      url
      id
      isPublic
    }
  }
`;
//# sourceMappingURL=osmosysSnap.js.map